import type { IxcBillingV1ChargeKeys } from '@interxfi/types';
import { type EntityPathBuilder, getResolvedPath } from '../../../util/routing/entity-paths';

export const BILLING_CHARGE_BASE_PATH = getResolvedPath('/billing/charge');

export const getBillingChargePath: EntityPathBuilder<IxcBillingV1ChargeKeys> = (context) => {
  switch (context.kind) {
    case 'list':
      return BILLING_CHARGE_BASE_PATH;
    case 'detail': {
      if (!context?.keys?.chargeId) {
        return undefined;
      }

      return getResolvedPath(`${BILLING_CHARGE_BASE_PATH}/$chargeId`, { chargeId: context.keys.chargeId });
    }
  }
};

export function getBillingChargeDetailPath(chargeId: string | undefined) {
  if (!chargeId) {
    return undefined;
  }

  return getBillingChargePath({ kind: 'detail', keys: { chargeId } });
}
